;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.openCategories = (function () {
    const initialize = function () {
      // let noScroll = false
      $('.js-openCategories').on('click', function (e) {
        e.preventDefault()
        $(this).siblings('.categories').toggle()
        // if (noScroll == false) {
        //   $('html, body').animate({scrollTop: '600px'}, 600)
        //   noScroll = true
        // } else {
        //   $('html, body').scrollTop(600)
        // }
      })
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.openCategories.initialize()
  })
}(jQuery, window))
